import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a5822a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-close" }
const _hoisted_2 = { class: "mt-4 mx-3 mb-2 text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 font-weight-bold" }, [
  /*#__PURE__*/_createTextVNode("\n        カイテクを退会しています。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("利用を再開しますか？\n      ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-size-12" }, [
  /*#__PURE__*/_createTextVNode("\n        すでに退会しているためご利用いただけません"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("質問に答えて復帰が出来ます\n      ")
], -1))
const _hoisted_5 = ["href"]

import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import ExternalLink from "@/const/externalLink";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReactivateAccountModal',
  props: {
  isShown: {
    type: Boolean,
    required: true
  }
},
  emits: ["close", "ok"],
  setup(__props, { emit: emits }) {





return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: __props.isShown,
    centered: "",
    "ok-only": "",
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    size: "md",
    "content-class": "mx-4",
    "header-class": "p-0",
    "footer-class": "d-flex justify-content-center py-2"
  }, {
    "modal-header": _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(FeatherIcon, {
          icon: "x-circle",
          size: "24",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
        })
      ])
    ]),
    "modal-footer": _withCtx(() => [
      _createVNode(AppButton, {
        class: "px-4 py-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('ok')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        再開する\n      ")
        ], undefined, true),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(),
        _hoisted_4,
        _createTextVNode(),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: _unref(ExternalLink).CONTACT,
            class: "link text-primary text-size-12"
          }, "身に覚えがない場合/お問い合わせはこちら", 8, _hoisted_5)
        ])
      ]),
      _createTextVNode()
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})